<template>
  <div class="page-wrapper">
    <div class="content container-fluid">
      <div class="page-header mb-4">
        <div class="row align-items-center">
          <div class="col">
            <h3 class="page-title">Quản Lý Dự Án</h3>
            <ul class="breadcrumb bg-transparent p-0">
              <li class="breadcrumb-item"><a href="/">Dashboard</a></li>
              <li class="breadcrumb-item active">Danh sách dự án</li>
            </ul>
          </div>
          <div class="col-auto">
            <div class="btn-group shadow-sm mr-3">
              <button
                class="btn btn-white"
                :class="{ active: viewMode === 'list' }"
                @click="viewMode = 'list'"
              >
                <i class="la la-list"></i>
              </button>
              <button
                class="btn btn-white"
                :class="{ active: viewMode === 'gantt' }"
                @click="viewMode = 'gantt'"
              >
                <i class="la la-stream"></i>
              </button>
            </div>
            <button
              class="btn btn-primary btn-rounded shadow"
              @click="openModalThem"
            >
              <i class="la la-plus"></i> Thêm Dự Án
            </button>
          </div>
        </div>
      </div>

      <div v-if="viewMode === 'gantt'" class="animate-fade">
        <div class="card border-0 shadow-lg rounded-lg">
          <div class="card-body p-0">
            <GanttChart :tasks="masterGanttData" @select-task="diToiChiTiet" />
          </div>
        </div>
        <div class="text-center mt-2 small text-muted">
          <i class="la la-info-circle"></i> Bấm vào thanh tiến độ để xem chi
          tiết
        </div>
      </div>

      <div v-if="viewMode === 'list'" class="animate-fade">
        <div class="card border-0 shadow-sm">
          <div class="table-responsive">
            <table class="table table-center table-hover mb-0">
              <thead class="thead-light">
                <tr>
                  <th>Dự án / Địa điểm</th>
                  <th>Loại hình</th>
                  <th>Ban Quản Lý</th>
                  <th>Khách hàng</th>
                  <th>Ngân sách</th>
                  <th>Tiến độ</th>
                  <th class="text-right">Hành động</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="da in store.danhSachCongTrinh"
                  :key="da.id"
                  @click="diToiChiTiet(da)"
                  class="cursor-pointer clickable-row"
                >
                  <td>
                    <div class="font-weight-bold text-primary small mb-1">
                      {{ da.code }}
                    </div>
                    <strong>{{ da.tenCongTrinh }}</strong>
                    <div class="small text-muted mt-1">
                      <i class="la la-map-marker text-danger"></i>
                      {{ da.diaChiCongTrinh || "Chưa cập nhật" }}
                    </div>
                  </td>

                  <td>
                    <span
                      class="badge badge-pill"
                      :class="
                        da.loaiCongTrinh === 'CONG_TRINH'
                          ? 'badge-soft-info'
                          : 'badge-soft-warning'
                      "
                    >
                      {{
                        da.loaiCongTrinh === "CONG_TRINH"
                          ? "Công trình"
                          : "Tại xưởng"
                      }}
                    </span>
                  </td>

                  <td>
                    <div class="d-flex align-items-center avatars-overlap">
                      <template v-if="da.listQuanLy && da.listQuanLy.length">
                        <div
                          v-for="(pm, idx) in da.listQuanLy.slice(0, 3)"
                          :key="pm.id"
                          class="avatar avatar-xs rounded-circle border border-white"
                          :title="pm.hoTen"
                        >
                          <img
                            v-if="pm.avatarUrl"
                            :src="pm.avatarUrl"
                            class="rounded-circle w-100 h-100 object-cover"
                          />
                          <span
                            v-else
                            class="avatar-title rounded-circle bg-primary text-white font-size-10 w-100 h-100 d-flex align-items-center justify-content-center"
                          >
                            {{ (pm.hoTen || "?").charAt(0) }}
                          </span>
                        </div>
                        <span
                          v-if="da.listQuanLy.length > 3"
                          class="avatar avatar-xs rounded-circle bg-light text-muted border border-white small d-flex align-items-center justify-content-center font-size-10"
                        >
                          +{{ da.listQuanLy.length - 3 }}
                        </span>
                      </template>
                      <span v-else class="text-muted small font-italic"
                        >--</span
                      >
                    </div>
                  </td>

                  <td>
                    <div class="font-weight-500">
                      {{ da.tenKhachHang || "--" }}
                    </div>
                  </td>

                  <td>{{ formatCurrency(da.nganSachDuKien) }}</td>

                  <td style="min-width: 150px">
                    <div class="d-flex align-items-center">
                      <div
                        class="progress flex-grow-1 mr-2"
                        style="height: 6px"
                      >
                        <div
                          class="progress-bar"
                          :class="getProgressColor(da.tienDo)"
                          :style="{ width: (da.tienDo || 0) + '%' }"
                        ></div>
                      </div>
                      <small>{{ da.tienDo || 0 }}%</small>
                    </div>
                  </td>

                  <td class="text-right">
                    <button
                      class="btn btn-sm btn-light border"
                      @click.stop="diToiChiTiet(da)"
                    >
                      <i class="la la-eye"></i>
                    </button>
                  </td>
                </tr>
                <tr v-if="!store.danhSachCongTrinh.length">
                  <td colspan="7" class="text-center py-5 text-muted">
                    Chưa có dự án nào.
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div v-if="hienThiModalThem">
        <div
          class="modal fade show d-block"
          tabindex="-1"
          style="background: rgba(0, 0, 0, 0.5)"
        >
          <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content border-0 shadow-lg">
              <form @submit.prevent="submitThemDuAn">
                <div class="modal-header">
                  <h5 class="modal-title font-weight-bold">Thêm Dự Án Mới</h5>
                  <button
                    type="button"
                    class="close"
                    @click="hienThiModalThem = false"
                  >
                    <span>&times;</span>
                  </button>
                </div>

                <div
                  class="modal-body custom-scroll"
                  style="max-height: 75vh; overflow-y: auto"
                >
                  <h6
                    class="text-uppercase text-muted font-weight-bold small mb-3"
                  >
                    1. Thông tin chung
                  </h6>
                  <div class="form-row">
                    <div class="col-md-8 form-group">
                      <label
                        >Tên dự án <span class="text-danger">*</span></label
                      >
                      <input
                        v-model="formThemDuAn.tenCongTrinh"
                        type="text"
                        class="form-control"
                        required
                        placeholder="Nhập tên dự án..."
                      />
                    </div>
                    <div class="col-md-4 form-group">
                      <label>Mã dự án (Optional)</label>
                      <input
                        v-model="formThemDuAn.code"
                        type="text"
                        class="form-control"
                        placeholder="Tự động"
                      />
                    </div>
                  </div>

                  <div class="form-group">
                    <label class="d-block font-weight-bold small text-muted"
                      >Loại hình</label
                    >
                    <div
                      class="custom-control custom-radio custom-control-inline"
                    >
                      <input
                        type="radio"
                        id="type1"
                        value="CONG_TRINH"
                        v-model="formThemDuAn.loaiCongTrinh"
                        class="custom-control-input"
                      />
                      <label class="custom-control-label" for="type1"
                        >Công trình thi công</label
                      >
                    </div>
                    <div
                      class="custom-control custom-radio custom-control-inline"
                    >
                      <input
                        type="radio"
                        id="type2"
                        value="DU_AN_XUONG"
                        v-model="formThemDuAn.loaiCongTrinh"
                        class="custom-control-input"
                      />
                      <label class="custom-control-label" for="type2"
                        >Dự án tại xưởng</label
                      >
                    </div>
                  </div>

                  <div class="form-group">
                    <label>Địa điểm thực hiện</label>
                    <input
                      v-model="formThemDuAn.diaChiCongTrinh"
                      type="text"
                      class="form-control"
                      placeholder="Số nhà, đường, quận/huyện..."
                    />
                  </div>

                  <h6
                    class="text-uppercase text-muted font-weight-bold small mb-3 mt-3"
                  >
                    2. Khách hàng & Nhân sự
                  </h6>
                  <div class="form-row">
                    <div class="col-md-6 form-group">
                      <label>Tên Khách hàng / Chủ đầu tư</label>
                      <input
                        v-model="formThemDuAn.tenKhachHang"
                        type="text"
                        class="form-control"
                      />
                    </div>
                    <div class="col-md-6 form-group">
                      <label>Địa chỉ / Liên hệ KH</label>
                      <input
                        v-model="formThemDuAn.diaChiKhachHang"
                        type="text"
                        class="form-control"
                      />
                    </div>
                  </div>

                  <div class="form-group">
                    <label>Ban Quản Lý (Chọn nhiều)</label>
                    <select
                      v-model="formThemDuAn.quanLyIds"
                      class="form-control custom-select"
                      multiple
                      size="3"
                    >
                      <option
                        v-for="user in store.usersOptions"
                        :key="user.idNguoiDung"
                        :value="user.idNguoiDung"
                      >
                        {{ user.hoTen }} ({{ user.tenDangNhap }})
                      </option>
                    </select>
                    <small class="form-text text-muted"
                      >Giữ phím <strong>Ctrl</strong> (hoặc Command) để chọn
                      nhiều người.</small
                    >
                  </div>

                  <h6
                    class="text-uppercase text-muted font-weight-bold small mb-3 mt-3"
                  >
                    3. Kế hoạch & Tài chính
                  </h6>
                  <div class="form-row">
                    <div class="form-group col-md-4">
                      <label
                        >Ngày bắt đầu <span class="text-danger">*</span></label
                      >
                      <input
                        v-model="formThemDuAn.ngayBatDau"
                        type="date"
                        class="form-control"
                        required
                      />
                    </div>
                    <div class="form-group col-md-4">
                      <label
                        >Ngày kết thúc (DK)
                        <span class="text-danger">*</span></label
                      >
                      <input
                        v-model="formThemDuAn.ngayKetThucDuKien"
                        type="date"
                        class="form-control"
                        required
                      />
                    </div>
                    <div class="form-group col-md-4">
                      <label>Ngân sách (VNĐ)</label>
                      <input
                        v-model.number="formThemDuAn.nganSachDuKien"
                        type="number"
                        class="form-control"
                        min="0"
                        placeholder="0"
                      />
                    </div>
                  </div>
                </div>
                <div class="modal-footer bg-light">
                  <button
                    type="button"
                    class="btn btn-secondary px-4"
                    @click="hienThiModalThem = false"
                  >
                    Hủy
                  </button>
                  <button
                    type="submit"
                    class="btn btn-primary px-4 font-weight-bold shadow-sm"
                  >
                    <i class="la la-check-circle mr-1"></i> Tạo Dự Án
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from "vue";
import { useRouter } from "vue-router";
import { useCongTrinhStore } from "@/stores/congTrinhStore";
import GanttChart from "./components/GanttChart.vue";

const store = useCongTrinhStore();
const router = useRouter();
const viewMode = ref("list");
const hienThiModalThem = ref(false);

// Form Data (Khớp với DTO Backend mới)
const formThemDuAn = ref({
  code: "",
  tenCongTrinh: "",
  loaiCongTrinh: "CONG_TRINH", // Default Value
  diaChiCongTrinh: "",
  tenKhachHang: "",
  diaChiKhachHang: "",
  quanLyIds: [], // Mảng ID quản lý
  nganSachDuKien: null,
  ngayBatDau: new Date().toLocaleDateString('sv-SE'), // Mặc định hôm nay
  ngayKetThucDuKien: "", // Backend dùng ngayKetThucDuKien
});

// Load dữ liệu khi vào trang
onMounted(async () => {
  await store.fetchDanhSachCongTrinh();
  // Gọi API lấy danh sách User để nạp vào dropdown chọn quản lý
  await store.fetchUsersOptions();
});

// Mở Modal & Reset Form
const openModalThem = () => {
  hienThiModalThem.value = true;
  formThemDuAn.value = {
    code: "",
    tenCongTrinh: "",
    loaiCongTrinh: "CONG_TRINH",
    diaChiCongTrinh: "",
    tenKhachHang: "",
    diaChiKhachHang: "",
    quanLyIds: [],
    nganSachDuKien: 0,
    ngayBatDau: new Date().toLocaleDateString('sv-SE'),
    ngayKetThucDuKien: "",
  };
};

// Submit Form
const submitThemDuAn = async () => {
  if (
    !formThemDuAn.value.tenCongTrinh ||
    !formThemDuAn.value.ngayBatDau ||
    !formThemDuAn.value.ngayKetThucDuKien
  ) {
    alert("Vui lòng nhập Tên dự án và Thời gian bắt đầu - kết thúc.");
    return;
  }

  try {
    const res = await store.themCongTrinh({ ...formThemDuAn.value });
    alert("Tạo dự án thành công!");
    hienThiModalThem.value = false;
    diToiChiTiet(res);
  } catch (error) {
    alert("Lỗi tạo dự án: " + (error.response?.data?.message || error.message));
  }
};

// Navigation
const diToiChiTiet = (item) => {
  console.log("Chuyển đến dự án:", item.id);
  router.push({
    name: "ChiTietCongTrinh",
    params: { id: item.id },
  });
};

// Helper: Format tiền tệ
const formatCurrency = (value) => {
  if (value === undefined || value === null || isNaN(value)) {
    return "0 ₫";
  }
  return new Intl.NumberFormat("vi-VN", {
    style: "currency",
    currency: "VND",
    maximumFractionDigits: 0,
  }).format(value);
};

// Helper: Màu sắc thanh tiến độ
const getProgressColor = (val) => {
  if (val >= 100) return "bg-success";
  if (val >= 50) return "bg-info";
  return "bg-warning";
};

// Helper: Gantt Data Mapping
const masterGanttData = computed(() => {
  const colors = ["#1890ff", "#722ed1", "#eb2f96", "#faad14", "#52c41a"];
  return store.danhSachCongTrinh.map((da, index) => {
    return {
      id: da.id,
      shortName: da.tenCongTrinh ? da.tenCongTrinh.charAt(0) : "D",
      name: da.tenCongTrinh,
      startDay: da.ngayBatDau,
      duration: da.ngayKetThucDuKien, // Dùng ngày dự kiến cho Gantt
      progress: da.tienDo,
      color: colors[index % colors.length],
    };
  });
});
</script>

<style scoped>
/* Animation */
/* 
.animate-fade {
  animation: fadeIn 0.5s ease-out;
}
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
*/
/* Avatar Overlap Style */
.avatars-overlap .avatar {
  margin-right: -10px;
  transition: transform 0.2s;
  border: 2px solid #fff;
  background-color: #fff;
}
.avatars-overlap .avatar:hover {
  transform: translateY(-3px);
  z-index: 5;
}
.object-cover {
  object-fit: cover;
}
.font-size-10 {
  font-size: 10px;
}

/* Badge Soft Colors */
.badge-soft-info {
  background-color: #e3f2fd;
  color: #0d6efd;
}
.badge-soft-warning {
  background-color: #fff3cd;
  color: #856404;
}

/* Row Clickable */
.cursor-pointer {
  cursor: pointer;
}
.clickable-row {
  transition: background-color 0.2s;
}
.clickable-row:hover {
  background-color: #f8f9fa !important;
}
</style>
